<template>
  <!-- eslint-disable  -->
  <div v-if="formdata.visible"  @focusin.capture="clearMessages" @focusout.capture="clearMessages" @mousedown.capture="clearMessages" :id="formdata.field_name + '_block'">
    <slot></slot>
    <div v-if="formdata.field_type == 'vgs_credit_card'" class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-vgs-creditcard :vgsStatus="vgsStatus" :fieldData="formdata" :inputType="'tel'" :key="vgsStatus.keys[formdata.field_name]"></input-vgs-creditcard>
      </div>

        <field-subtext :fieldData="formdata"></field-subtext>

        <field-messages :fieldData="formdata"></field-messages>
    </div>
      <div v-if="formdata.field_type == 'vgs_loannumber'" class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <inputvgsloannumber :vgsStatus="vgsStatus" :fieldData="formdata" :inputType="'tel'" :key="vgsStatus.keys[formdata.field_name]"></inputvgsloannumber>
      </div>

        <field-subtext :fieldData="formdata"></field-subtext>

        <field-messages :fieldData="formdata"></field-messages>
    </div>
    <div v-if="formdata.field_type == 'vgs_bank_account'" class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-vgs-bank-account :vgsStatus="vgsStatus" :fieldData="formdata" :inputType="'tel'" :key="vgsStatus.keys[formdata.field_name]"></input-vgs-bank-account>
      </div>

        <field-subtext :fieldData="formdata"></field-subtext>

        <field-messages :fieldData="formdata"></field-messages>
    </div>
    <div v-if="formdata.field_type == 'vgs_ba_installment'" class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-vgs-bank-account-installment :vgsStatus="vgsStatus" :fieldData="formdata" :inputType="'tel'" :key="vgsStatus.keys[formdata.field_name]"></input-vgs-bank-account-installment>
      </div>

        <field-subtext :fieldData="formdata"></field-subtext>

        <field-messages :fieldData="formdata"></field-messages>
    </div>
    <!-- CC number installment -->
    <div v-if="formdata.field_type == 'vgs_cc_i'" class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-vgs-credit-card-installment :vgsStatus="vgsStatus" :fieldData="formdata" :inputType="'tel'" :key="vgsStatus.keys[formdata.field_name]"></input-vgs-credit-card-installment>
      </div>

        <field-subtext :fieldData="formdata"></field-subtext>

        <field-messages :fieldData="formdata"></field-messages>
    </div>

    <!-- CC CVV -->
    <div v-if="formdata.field_type == 'vgs_cc_cvv'" class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-vgs-cvc :vgsStatus="vgsStatus" :fieldData="formdata" :inputType="'tel'" :key="vgsStatus.keys[formdata.field_name]"></input-vgs-cvc>
      </div>

        <field-subtext :fieldData="formdata"></field-subtext>

        <field-messages :fieldData="formdata"></field-messages>
    </div>

    <!-- CC CVV installment -->
    <div v-if="formdata.field_type == 'vgs_cc_cvv_i'" class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-vgs-cvc-installment :vgsStatus="vgsStatus" :fieldData="formdata" :inputType="'tel'" :key="vgsStatus.keys[formdata.field_name]"></input-vgs-cvc-installment>
      </div>

        <field-subtext :fieldData="formdata"></field-subtext>

        <field-messages :fieldData="formdata"></field-messages>
    </div>
    <div v-if="formdata.field_type == 'number_medium'" class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-numberalt :fieldData="formdata" :inputType="'text'"  :formIndex="formIndex" :sendPostRule="sendPostRule" :ref="formdata.field_name"></input-numberalt>
      </div>

        <field-subtext :fieldData="formdata"></field-subtext>

        <field-messages :fieldData="formdata"></field-messages>
    </div>
    <div v-if="formdata.field_type === 'numberterm_miles' || formdata.field_type === 'numberterm_days'" class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-calculation :fieldData="formdata" :inputType="'text'"  :formIndex="formIndex" :sendPostRule="sendPostRule" :ref="formdata.field_name" ></input-calculation>
      </div>

        <field-subtext :fieldData="formdata"></field-subtext>

        <field-messages :fieldData="formdata"></field-messages>
    </div>
    <div v-if="formdata.field_type == 'input_number'" class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-number :fieldData="formdata" :inputType="'text'" :sendPostRule="sendPostRule"></input-number>
      </div>

        <field-subtext :fieldData="formdata"></field-subtext>

        <field-messages :fieldData="formdata"></field-messages>
    </div>
    <div v-if="formdata.field_type=='money_medium'" class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-money :fieldData="formdata" :inputType="'money'" :sendPostRule="sendPostRule" :ref="formdata.field_name"></input-money>
      </div>

        <field-subtext :fieldData="formdata"></field-subtext>

        <field-messages :fieldData="formdata"></field-messages>
    </div>
    <div v-if="formdata.field_type === 'label'">
      <field-display :fieldData="formdata" :j='j'></field-display>
    </div>
    <div v-if="formdata.field_type === 'text_large' ||
      formdata.field_type === 'text_long' ||
      formdata.field_type === 'text_medium' ||
      formdata.field_type === 'text_medium_right' ||
      formdata.field_type === 'text_short' ||
      formdata.field_type === 'text_short_inline' ||
      formdata.field_type === 'text_inline' ||
      formdata.field_type === 'text_short_inline_first' ||
      formdata.field_type === 'text_inline_first' ||
      formdata.field_type === 'email_large' || formdata.field_type === 'email_long' || formdata.field_type === 'email_pii'"
      class="position-relative">
        <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-text :fieldData="formdata" :inputType="'text'" :sendPostRule="sendPostRule" :ref="formdata.field_name"></input-text>
      </div>

        <field-subtext :fieldData="formdata"></field-subtext>

        <field-messages :fieldData="formdata"></field-messages>
    </div>
    <div v-if="formdata.field_type === 'input_integer'" class="position-relative" >
        <field-info :fieldData="formdata"></field-info>
      <div class="field-container pr-2">
        <input-integer :fieldData="formdata" :sendPostRule="sendPostRule" :ref="formdata.field_name"></input-integer>
      </div>
        <field-subtext :fieldData="formdata"></field-subtext>
        <field-messages :fieldData="formdata"></field-messages>
    </div>
    <div v-if="formdata.field_type === 'input_textpii'" class="position-relative">
        <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-textpii :fieldData="formdata" :sendPostRule="sendPostRule"></input-textpii>
      </div>

        <field-subtext :fieldData="formdata"></field-subtext>

        <field-messages :fieldData="formdata"></field-messages>
    </div>
    <div v-if="formdata.field_type === 'address_long'" class="position-relative">
        <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-address :fieldData="formdata" :inputType="'text'" :ref="formdata.field_name"></input-address>
      </div>

        <field-subtext :fieldData="formdata"></field-subtext>

        <field-messages :fieldData="formdata"></field-messages>
    </div>
    <div v-if="formdata.field_type === 'phonenumber_large' || formdata.field_type === 'phonenumber_long'" class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-phone :fieldData="formdata" :inputType="'tel'" :sendPostRule="sendPostRule" :ref="formdata.field_name"></input-phone>
      </div>

      <field-subtext :fieldData="formdata"></field-subtext>

      <field-messages :fieldData="formdata"></field-messages>
    </div>
    <div v-if="formdata.field_type === 'creditcard_large' || formdata.field_type === 'creditcard_long'" class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-creditcard :fieldData="formdata" :inputType="'tel'"></input-creditcard>
      </div>

      <field-subtext :fieldData="formdata"></field-subtext>

      <field-messages :fieldData="formdata"></field-messages>
    </div>
    <div v-if="formdata.field_type === 'input_creditcardfaux'" class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-creditcardfaux :fieldData="formdata" :inputType="'tel'"></input-creditcardfaux>
      </div>

      <field-subtext :fieldData="formdata"></field-subtext>

      <field-messages :fieldData="formdata"></field-messages>
    </div>
    <!-- Single radio -->
    <div v-if="formdata.field_type === 'radio_single'" class="field-container mt-2">
      <input-radio :fieldData="formdata" :sendPostRule="sendPostRule" :ref="formdata.field_name"></input-radio>
      <div class="ml-4"><field-info :fieldData="formdata"></field-info></div>
      <field-subtext :fieldData="formdata"></field-subtext>
      <field-messages :fieldData="formdata"></field-messages>
    </div>
    <!-- Single radio with label and answer option end-->
    <div v-if="formdata.field_type === 'radio' ||
      formdata.field_type === 'radio_inline' ||
      formdata.field_type === 'radio_inline_first' ||
      formdata.field_type === 'radio_single_VIN'">
      <field-info :fieldData="formdata"></field-info>
      <div class="field-container pr-2">
        <input-radio :fieldData="formdata" :sendPostRule="sendPostRule" :ref="formdata.field_name"></input-radio>
      </div>
      <field-subtext :fieldData="formdata"></field-subtext>
      <field-messages :fieldData="formdata"></field-messages>
    </div>
    <div v-if="formdata.field_type === 'select_large' ||
      formdata.field_type === 'select_inline' ||
      formdata.field_type === 'select_inline_first' ||
      formdata.field_type === 'select_large_bottom' ||
      formdata.field_type === 'select_long' ||
      formdata.field_type === 'select_long_bottom' ||
      formdata.field_type === 'select_medium' ||
      formdata.field_type === 'select_medium_bottom' ||
      formdata.field_type === 'select_short' ||
      formdata.field_type === 'select_images'"
      class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-select-images v-if="formdata.field_type === 'select_long'" :fieldData="formdata" :sendPostRule="sendPostRule"></input-select-images>
        <input-select v-else :fieldData="formdata" :sendPostRule="sendPostRule" :ref="formdata.field_name"></input-select>
      </div>
      <field-subtext :fieldData="formdata"></field-subtext>
      <field-messages :fieldData="formdata"></field-messages>
    </div>
    <div v-if="formdata.field_type === 'select_CCType'"
      class="position-relative invisible" style="height: 0">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-select-credit-card-type :fieldData="formdata" :sendPostRule="sendPostRule"></input-select-credit-card-type>
      </div>
      <field-subtext :fieldData="formdata"></field-subtext>
      <field-messages :fieldData="formdata"></field-messages>
    </div>
    <div v-if="formdata.field_type === 'checkbox'" class="position-relative">
      <div class="form-group col-12 px-0" v-if="formdata.script">
          <div class="form-text text-script"  v-html="formdata.script"></div>
        </div>
      <div class="field-container ml-4 pr-2">
        <input-checkbox :fieldData="formdata" :sendPostRule="sendPostRule" :ref="formdata.field_name"></input-checkbox>
        <field-info :fieldData="formdata"></field-info>
        <field-subtext :fieldData="formdata"></field-subtext>
      </div>
      <field-messages :fieldData="formdata" class="position-relative"></field-messages>
    </div>
    <div v-if="formdata.field_type === 'multicheckbox' ||
      formdata.field_type === 'checkbox_inline' ||
      formdata.field_type === 'checkbox_inline_first'"
      class="position-relative">
      <field-info :fieldData="formdata"></field-info>
      <div v-if="formdata.field_type === 'multicheckbox'" class='multicheckbox-err pb-1'>
        <field-messages :fieldData="formdata"></field-messages>
      </div>
      <div class="pb-1">
      <field-subtext :fieldData="formdata"></field-subtext>
      </div>
      <div class="field-container pr-2">
        <input-multicheckbox :fieldData="formdata" :sendPostRule="sendPostRule"></input-multicheckbox>
      </div>
      <div v-if="formdata.field_type !== 'multicheckbox'">
       <field-messages :fieldData="formdata"></field-messages>
      </div>
    </div>
    <div v-if="formdata.field_type == 'date_long' || formdata.field_type == 'date_long_pii'" class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-datelong :fieldData="formdata" :sendPostRule="sendPostRule" :ref="formdata.field_name"></input-datelong>
      </div>
      <field-subtext :fieldData="formdata"></field-subtext>
      <field-messages :fieldData="formdata"></field-messages>
    </div>
    <div v-if="formdata.field_type == 'date_mmyyyy'" class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-datemmyyyy :fieldData="formdata" :sendPostRule="sendPostRule"></input-datemmyyyy>
      </div>
      <field-subtext :fieldData="formdata"></field-subtext>
      <field-messages :fieldData="formdata"></field-messages>
    </div>
    <div v-if="formdata.field_type == 'date_short'" class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-dateshort :fieldData="formdata" :sendPostRule="sendPostRule"></input-dateshort>
      </div>
      <field-subtext :fieldData="formdata"></field-subtext>
      <field-messages :fieldData="formdata"></field-messages>

    </div>
    <div v-if="formdata.field_type === 'b_input_group_append'" class="position-relative">
      <field-info :fieldData="formdata"></field-info>

      <div class="field-container pr-2">
        <input-group :fieldData="formdata" :sendPostRule="sendPostRule"></input-group>
      </div>
      <field-subtext :fieldData="formdata"></field-subtext>
      <field-messages :fieldData="formdata"></field-messages>

    </div>
  </div>
</template>


<script>
/* eslint-disable */
import FieldDisplay from '../presentational/FieldDisplay';
import InputText from '../interactive/InputText';
import InputInteger from '../interactive/InputInteger';
import InputTextpii from '../interactive/InputTextpii';
import InputNumber from '../interactive/InputNumber';
import InputNumberalt from '../interactive/InputNumberalt';
import InputAddress from '../interactive/InputAddress';
import InputPhone from '../interactive/InputPhone';
import InputVgsBankAccount from '../interactive/InputVgsBankAccount';
import InputVgsBankAccountInstallment from '../interactive/InputVgsBankAccountInstallment';
import InputVgsCreditcard from '../interactive/InputVgsCreditcard';
import InputCreditcard from '../interactive/InputCreditcard';
import InputCreditcardfaux from '../interactive/InputCreditcardfaux';
import InputRadio from '../interactive/InputRadio';
import InputRadioSingle from '../interactive/InputRadioSingle';
import InputSelect from '../interactive/InputSelect';
import InputSelectCreditCardType from '../interactive/InputSelectCreditCardType';
import InputSelectImages from '../interactive/InputSelectImages';
import InputCheckbox from '../interactive/InputCheckbox';
import InputMulticheckbox from '../interactive/InputMulticheckbox';
import InputDatelong from '../interactive/InputDatelong';
import InputDatemmyyyy from '../interactive/InputDatemmyyyy';
import InputDateshort from '../interactive/InputDateshort';
import InputMoney from '../interactive/InputMoney';
import InputCalculation from '../interactive/InputCalculation';
import FieldInfo from '../presentational/FieldInfo';
import FieldMessages from '../presentational/FieldMessages';
import FieldSubtext from '../presentational/FieldSubtext';
import InputGroup from '../interactive/InputGroup';
import InputVgsCreditCardInstallment from '../interactive/InputVgsCreditCardInstallment';
import InputVgsCvc from '../interactive/InputVgsCvc';
import InputVgsCvcInstallment from '../interactive/InputVgsCvcInstallment';
import inputvgsloannumber from '../interactive/InputVgsLoanNumber';

export default {
  inject: ['$validator'],
  props: ['formdata', 'i', 'j', 'formIndex', 'vgsStatus'],
  data() {
    return {
    };
  },
  components: {
    FieldDisplay,
    InputText,
    InputInteger,
    InputTextpii,
    InputNumber,
    InputAddress,
    InputPhone,
    InputVgsBankAccount,
    InputVgsBankAccountInstallment,
    InputVgsCreditcard,
    InputCreditcard,
    InputCreditcardfaux,
    InputRadio,
    FieldInfo,
    FieldSubtext,
    FieldMessages,
    InputSelect,
    InputSelectCreditCardType,
    InputSelectImages,
    InputCheckbox,
    InputMulticheckbox,
    InputDatelong,
    InputDatemmyyyy,
    InputDateshort,
    InputRadioSingle,
    InputMoney,
    InputCalculation,
    InputNumberalt,
    InputGroup,
    InputVgsCreditCardInstallment,
    InputVgsCvc,
    InputVgsCvcInstallment,
    inputvgsloannumber,
  },
  methods: {
    /**
     * Exposes errors by expanding any of its collapsed parents
     */
    expose_errors() {
      if (this.formdata.has_error) {
        const me = this.$el; // Access this Vue element
        let myParent = me;
        /* eslint no-cond-assign: */
        // Traverse the DOM upward, looking for collapsed elements
        while ((myParent = myParent.parentElement) && myParent.tagName !== 'FORM') {
          if (myParent.classList.contains('collapse') && !myParent.classList.contains('show')) {
            if (sessionStorage.getItem('flowType') === 'bundle' || sessionStorage.getItem('flowType') === 'cabundle' || sessionStorage.getItem('flowType') === 'rabundle') {
              this.$parent.$parent.toggle_collapse(myParent, true); // This parent is collapsed, so expand it
            } else {
            this.$parent.toggle_collapse(myParent, true); // This parent is collapsed, so expand it
          }
        }
        }

        if (!this.first_error) {
          this.first_error = `${this.formdata.field_name}_block`; // Set this view's first error in the state
          document.getElementById(this.first_error).scrollIntoView(); // Scroll to the first error
          window.scrollBy(0, -180); // TODO: Use nav margin + height of #form-headings
        }
      }
    },
    /**
     * placeholder function to call parent sendpost from rule mixin
     */
    sendPostRule(url) {
      if ((sessionStorage.getItem('flowType') === 'bundle' || sessionStorage.getItem('flowType') === 'cabundle' || sessionStorage.getItem('flowType') === 'rabundle') && this.$router.currentRoute.path.includes('/checkout')) {
        if (url.includes('QTE_PRP_')) {
          this.$parent.$parent.sendBundlePost(url);
        } else {
          this.$parent.$parent.sendPost(url);
        }
      } else {
      this.$parent.sendPost(url);
      }
    },
    /**
     * The validation message overlaps the interactive form element, so it is cleared
     * once the components containing the element is clicked.
     */
    clearMessages() {
      this.formdata.has_error = false; // Reset API errors to false upon any interaction
      this.errors.remove(this.formdata.field_name); // Temporarily hide the validation message
    },
  },
  mounted() {
    this.expose_errors();
  },
  computed: {
    /**
     * Track this view's first field-level error by storing it in the state. This is reset
     * to `null` upon creation of each view.
     */
    first_error: {
      get() {
        return this.$store.state.first_error;
      },
      set(value) {
        this.$store.state.first_error = value;
      },
    },
  },
};
</script>

<style lang="scss">
.field-container {
  position: relative; /* Needed to position 'yesreq' messages on top of field element */
}
.multicheckbox-err .required-error-block{
  display:block !important;
}
.multicheckbox-err i{
  display:none !important;
}
.multicheckbox-err .text-danger{
  font-size:12px;
  color:#BB0000 !important;
  background-color: #fff !important;
  padding:0px !important;
  margin:0px !important;
  line-height:16px;
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/FormBlock.vue?7447bb44